var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6963_10350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.06087 0 10.0783 0.395088 10.8284 1.09835C11.5786 1.80161 12 2.75544 12 3.75C12 4.74456 11.5786 5.69839 10.8284 6.40165C10.0783 7.10491 9.06087 7.5 8 7.5C6.93913 7.5 5.92172 7.10491 5.17157 6.40165C4.42143 5.69839 4 4.74456 4 3.75C4 2.75544 4.42143 1.80161 5.17157 1.09835C5.92172 0.395088 6.93913 0 8 0ZM8 9.375C12.42 9.375 16 11.0531 16 13.125V15H0V13.125C0 11.0531 3.58 9.375 8 9.375Z",
    fill: "#E30000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6963_10350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedUser);
export default __webpack_public_path__ + "static/media/red-user.bc16152d4759a24069da43a450f2fc04.svg";
export { ForwardRef as ReactComponent };